import AppHeader from "../../layout/AppHeader";
import Couriers from '../../xpost/views/umov/couriers/Couriers.vue';
import CouriersAdd from '../../xpost/views/umov/couriers/CouriersAdd.vue';

const CouriersRoutes = [
  {
    path: "/cadastro/entregador",
    name: "couriers",
    components: {
      header: AppHeader,
      default: Couriers,
    }
  },
  {
    path: "/cadastro/entregador/adicionar",
    name: "couriers.add",
    components: {
      header: AppHeader,
      default: CouriersAdd,
    }
  },
  {
    path: "/cadastro/entregador/editar/:id",
    name: "couriers.edit",
    components: {
      header: AppHeader,
      default: CouriersAdd,
    }
  },
]

export default CouriersRoutes;